import { takeLatest, put, select } from 'redux-saga/effects';
import { PCStoreJsBridge } from '../nativeapi';
import {
  DOWNLOAD_ADD_SOFT,
  DOWNLOAD_ADD_SOFT_LIST,
  DOWNLOAD_CANCEL_SOFT,
  DOWNLOAD_GET_SOFT_LIST,
  DOWNLOAD_GET_SOFT_LIST_SUCCESS,
} from '../constants/downloadTask';
import { capitalizeObj, logNative } from '../utils/utils';
import { cacheKeys } from '../constants/storageKeys';

function createOneTask(param) {
  let attr = {
    act: 'add',
    avspeed: 0,
    dlspeed: 0,
    dlsz: 0,
    eCode: 0,
    msg: '',
    progress: 0,
    statFrom: 'inQ',
    status: 'wait',
    sz: 0,
    taskId: '',
  };
  let soft = {};
  if (param.androidType === '1') {
    soft.type = 'apk';
    soft.apk = {
      pkg: param.packageName,
      vc: param.versionCode,
      vn: param.version,
      BizInfo: param.bizInfo,
      LogoFile: param.logoFile,
      SoftName: param.softName,
    };
    if (param.logInfo) {
      soft.apk.LogInfo = JSON.stringify({
        source: param.logInfo.source,
        source_p: param.logInfo.source_p,
        source_pp: param.logInfo.source_pp,
        search_type: param.logInfo.search_type || undefined,
        search_word: param.logInfo.search_word || undefined,
        type: param.logInfo.type || 'd',
      });
    }
  } else {
    soft = {
      type: 'pc',
      pc: capitalizeObj({
        ...param,
        SoftID: param.SoftID || param.softID || param.SoftId || param.softId,
        Version: param.version,
        Installparams: param.installparams || {},
      }),
    };

    if (param.logInfo) {
      soft.pc.LogInfo = JSON.stringify({
        source: param.logInfo.source,
        source_p: param.logInfo.source_p,
        source_pp: param.logInfo.source_pp,
        search_type: param.logInfo.search_type || undefined,
        search_word: param.logInfo.search_word || undefined,
        type: param.logInfo.type || 'd',
      });
    }
  }
  return { ...soft, attr };
}

/**
 * 安装单个应用
 * @param {*} param0
 */
function* downloadAddSoft({ param }) {
  try {
    const softs = yield select(state => state.downloadTask.softs);
    const found = softs.find(
      v =>
        (v.type === 'apk' && param.androidType === '1' && param.packageName === v.apk.pkg) ||
        (v.type === 'pc' &&
          param.androidType !== '1' &&
          (param.SoftID || param.softID || param.SoftId || param.softId) === v.pc.SoftID),
    );
    if (found && found.attr && found.attr.act === 'error') {
      yield PCStoreJsBridge.downloadRetry({ ...found });
    } else if (!found) {
      // 添加任务的时候，先组装手动添加一个任务到任务别表，解决任务列表中数据不足的问题
      yield put({
        type: DOWNLOAD_GET_SOFT_LIST_SUCCESS,
        payload: [...softs, createOneTask(param)],
      });
      // 添加下载任务
      yield PCStoreJsBridge.downloadAdd({ ...param });
      // 重新获取一次list
      yield downloadGetSoftList();
    }
  } catch (error) {
    logNative(`安装单个应用 downloadAddSoft 错误 ${error}`, error);
  }
}

export function* watchDownloadAddSoft() {
  yield takeLatest(DOWNLOAD_ADD_SOFT, downloadAddSoft);
}

/**
 * sleep 阻止代码运行
 * @param {*} time
 * @returns
 */
const sleep = time => {
  return new Promise(resolve => setTimeout(resolve, time));
};

/**
 * 安装单个应用
 * @param {*} param
 */
function* downloadAddSoftList({ params }) {
  try {
    if (!(params?.length > 0)) {
      return;
    }
    for (let i = 0; i < params.length; i += 1) {
      let param = params[i];
      const softs = yield select(state => state.downloadTask.softs);
      const found = softs.find(
        v =>
          (v.type === 'apk' && param.androidType === '1' && param.packageName === v.apk.pkg) ||
          (v.type === 'pc' &&
            param.androidType !== '1' &&
            (param.SoftID || param.softID || param.SoftId || param.softId) === v.pc.SoftID),
      );
      if (found) {
        if (found?.attr && found?.attr?.act === 'error') {
          yield PCStoreJsBridge.downloadRetry({ ...found });
        }
      } else {
        // 这里批量添加任务，每一次循环添加一个任务，每一次循环yield put每次触发一次action
        // 无延时的循环触发action会使得上一次action被覆盖，而不会生效。
        // 所以做一个sleep函数，让添加任务慢慢添加。避免action被覆盖的问题。
        yield sleep(350);
        // 添加任务的时候，先组装手动添加一个任务到任务列表，解决任务列表中数据不足的问题
        yield put({
          type: DOWNLOAD_GET_SOFT_LIST_SUCCESS,
          payload: [...softs, createOneTask(param)],
        });
        // 添加下载任务
        yield PCStoreJsBridge.downloadAdd({ ...param });
      }
    }
    // 重新获取一次list
    yield downloadGetSoftList();
  } catch (error) {
    logNative(`安装多个应用 downloadAddSoftList 错误 ${error}`, error);
  }
  // try {
  //   if (params.length > 0) {
  //     for (let i = 0; i < params.length; i += 1) {
  //       yield downloadAddSoft({ param: params[i] });
  //     }
  //   }
  // } catch (error) {
  //   logNative(`安装多个应用 downloadAddSoftList 错误 ${error}`, error);
  // }
}

export function* watchDownloadAddSoftList() {
  yield takeLatest(DOWNLOAD_ADD_SOFT_LIST, downloadAddSoftList);
}

/**
 * 取消安装单个应用
 * @param {*} param0
 */
function* downloadCancelSoft({ param }) {
  try {
    const softs = yield select(state => state.downloadTask.softs);
    yield PCStoreJsBridge.downloadCancel({ ...param });
    yield downloadGetSoftList();
  } catch (error) {
    logNative(`取消安装单个应用 downloadCancelSoft 错误 ${error}`, error);
  }
}

export function* watchDownloadCancelSoft() {
  yield takeLatest(DOWNLOAD_CANCEL_SOFT, downloadCancelSoft);
}

/**
 * 获取任务列表
 * @param {} param0
 */
function* downloadGetSoftList() {
  try {
    const ret = yield PCStoreJsBridge.downloadList();
    if (ret && ret.dl_list) {
      yield put({
        type: DOWNLOAD_GET_SOFT_LIST_SUCCESS,
        payload: ret.dl_list || [],
      });
    }
  } catch (error) {
    logNative(`获取任务列表 downloadGetSoftList 错误 ${error}`, error);
  }
}

export function* watchDownloadGetSoftList() {
  yield takeLatest(DOWNLOAD_GET_SOFT_LIST, downloadGetSoftList);
}
